import styled from "styled-components";
import { media, theme } from "../../theme/theme";

export const V3CNWrapper = styled.div<{ $isPrivateView: boolean }>`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 38px;

    > div {
        display: block;
        max-width: calc(100%);

        &:first-child {
            ${media.custom(theme.v3.layout.sidebarLayout.mobile)} {
                max-width: ${({ $isPrivateView }) => $isPrivateView ? "calc(100% - 200px)" : undefined};
            }
        }

        ${media.custom(theme.v3.layout.sidebarLayout.mobile)} {
            display: inline-flex;
        }
    }

    @media print {
        display: none;
    }
`;